import * as d3 from "d3";
import AbstractForceGenerator from "./AbstractForceGenerator";

export default class RadialForceGenerator extends AbstractForceGenerator {
    // Public:
    constructor(cParams) {
        super();
        this.saveParams(cParams);
        this.saveOrigin();
        this.createDiscriminationFunction();
        this.createRadiusFunction();
        this.createStrengthFunction();
    }

    compute() {
        let strengthFunc = this._strengthFunc;
        let radiusFunc = this._radiusFunc;
        let origin = this._origin;
        let force = d3
            .forceRadial()
            .strength(strengthFunc)
            .radius(radiusFunc)
            .x(origin.x)
            .y(origin.y);
        return force;
    }

    // Private:
    saveParams(cParams) {
        this._strength = cParams.strength;
        this._cluster = cParams.cluster;
    }

    saveOrigin() {
        let origin = {
            x: this._cluster.x,
            y: this._cluster.y,
        };
        this._origin = origin;
    }

    createRadiusFunction() {
        let cluster = this._cluster;
        let isNodeInCluster = d => this.isNodeInCluster(d);
        let func = function(d) {
            if (isNodeInCluster(d)) {
                let radius = 0;
                switch (d.category) {
                    case "master":
                        radius = cluster.masterRadius;
                        break;
                    case "solo":
                        radius = cluster.soloRadius;
                        break;
                    case "cluster":
                        radius = cluster.clusterRadius;
                        break;
                    case "shared":
                        radius = cluster.sharedRadius;
                        break;
                    default:
                        console.error("Invalid node category.");
                        break;
                }
                return radius;
            } else {
                return 0;
            }
        };
        this._radiusFunc = func;
    }

    createStrengthFunction() {
        let strength = this._strength;
        let isNodeInClusterFunc = d => this.isNodeInCluster(d);
        let func = function(d) {
            if (isNodeInClusterFunc(d)) return strength;
            else return 0;
        };
        this._strengthFunc = func;
    }

    createDiscriminationFunction() {
        let cluster = this._cluster;
        let func = function(d) {
            const index = d.number;
            const indices = cluster.forcibleNodesIndices;
            const indexIsForcible = indices.indexOf(index) !== -1;
            if (indexIsForcible) return true;
            else return false;
        };
        this.isNodeInCluster = func;
    }
}
